import "./locationDetailsTestOrdersComponent.scss";
import StatusCardComponent from "../../../shared/components/status-card/statusCardComponent";
import CardComponent from "../../../shared/components/card/cardComponent";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import {CommonService} from "../../../shared/services";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import Grid from "@mui/material/Grid";
import DetailsDataKeyValueComponent
    from "../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import AddIcon from "@mui/icons-material/Add";
import React, {useCallback, useEffect, useState} from "react";

import {useNavigate, useParams} from "react-router-dom";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {useDispatch, useSelector} from "react-redux";
import {
    setFacilityDetailsForLocation,
    setLocationDetailsForTestOrder
} from "../../../store/actions/facilityAndLocation.action";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import SearchComponent from "../../../shared/components/search/SearchComponent";
import _ from "lodash";
import {IRootReducerState} from "../../../store/reducers";
import TestOrderListTableComponent
    from "../../test-order/test-order-list/test-order-list-table/TestOrderListTableComponent";
import {ImageConfig} from "../../../constants";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import commonService from "../../../shared/services/common.service";

interface LocationDetailsTestOrdersComponentProps {

}

const FiltersInitialState: any = {
    search: '',
}

const LocationDetailsTestOrdersComponent = (props: LocationDetailsTestOrdersComponentProps) => {
    const navigate = useNavigate();
    const params = useParams<{ locationId: string | undefined }>();
    const {locationId} = params;
    const [locationDetails, setLocationDetails] = useState<any>(undefined);
    const [isLocationDetailsLoading, setIsLocationDetailsLoading] = useState<boolean>(false);
    const [isLocationDetailsLoaded, setIsLocationDetailsLoaded] = useState<boolean>(false);
    const [isLocationDetailsLoadingFailed, setIsLocationDetailsLoadingFailed] = useState<boolean>(false);
    const dispatch = useDispatch();
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);


    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);

    useEffect(() => {
        if (queryParamData) {
            const data: any = {
                search: queryParamData.search || '',
                locationId: locationId,
            };
            setFilterData((prevState: any) => ({
                ...prevState, ...data
            }));
        }
    }, [queryParamData, locationId]);

    useEffect(() => {
        dispatch(setCurrentNavParams("Back", "Location", CommonService._routeConfig.LocationListRoute()));
        dispatch(setSideMenuView('compact'));
    }, [dispatch, navigate]);

    const getLocationDetails = useCallback(() => {
        const payload = {};
        let locationDetails: any = {};
        setIsLocationDetailsLoading(true);
        setIsLocationDetailsLoaded(false);
        setIsLocationDetailsLoadingFailed(false);
        CommonService._location.getLocationDetails(locationId, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    locationDetails = response.data;
                }
                setLocationDetails(locationDetails);
                setIsLocationDetailsLoading(false);
                setIsLocationDetailsLoaded(true);
                setIsLocationDetailsLoadingFailed(false);
            })
            .catch((error: any) => {
                setLocationDetails(locationDetails);
                setIsLocationDetailsLoading(false);
                setIsLocationDetailsLoaded(false);
                setIsLocationDetailsLoadingFailed(true);
            });
    }, [locationId]);

    useEffect(() => {
        if (locationId) {
            getLocationDetails();
        }
    }, [locationId, getLocationDetails]);


    return (
        <div className={'location-details-test-orders-component view-screen screen'}>
            {
                isLocationDetailsLoading && <div className="h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                isLocationDetailsLoadingFailed && <>
                    <StatusCardComponent title={"Location details failed to load"}/>
                </>
            }
            {
                isLocationDetailsLoaded &&
                <div className="view-details-wrapper">
                    <CardComponent className={'view-details-header-wrapper'}>
                        <div className="card-content ">
                            <div className="view-details-card-header-button-wrapper">
                                <div className="view-details-card-title">
                                    {
                                        <div className={'view-details-card-title-text'}>
                                            {CommonService.capitalizeFirstLetterOfEachWord(locationDetails?.name)}
                                        </div>
                                    }

                                    <div className={'heading-status pdd-left-15'}>
                                        <ChipComponent
                                            label={CommonService.capitalizeFirstLetter(locationDetails?.status)}
                                            variant={"outlined"}
                                            className={locationDetails?.status}/>

                                    </div>
                                </div>
                                <div className="view-details-options">
                                    <ButtonComponent
                                        className={"white-space-nowrap"}
                                        type="button"
                                        color={"primary"}
                                        variant={"contained"}
                                        fullWidth={false}
                                        handleClick={() => {
                                            navigate(CommonService._routeConfig.LocationDetailsRoute(locationId))
                                        }}
                                    >
                                        View/Edit Details
                                    </ButtonComponent>
                                </div>
                            </div>
                            <div className="view-details-content">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={2}>
                                        <DetailsDataKeyValueComponent
                                            title={"created on"}>
                                            <div className="view-details-value">
                                                <>
                                                    {commonService.formatDate(locationDetails?.createdAt)}
                                                    &nbsp;|&nbsp;
                                                    {commonService.formatTime(locationDetails?.createdAt)}
                                                </>
                                            </div>
                                        </DetailsDataKeyValueComponent>
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <DetailsDataKeyValueComponent
                                            title={"Added by"}>
                                            <div
                                                className="details-value">{locationDetails?.createdByDetails?.firstName + " " + locationDetails?.createdByDetails?.lastName}</div>
                                        </DetailsDataKeyValueComponent>
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <DetailsDataKeyValueComponent
                                            title={"Location Type"}>
                                            <div
                                                className="details-value">{locationDetails?.type || 'N/A'}</div>
                                        </DetailsDataKeyValueComponent>
                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <DetailsDataKeyValueComponent
                                            title={"Facility Name"}>
                                            <div
                                                className="details-value"> {locationDetails?.facilityDetails?.name ? CommonService.capitalizeFirstLetterOfEachWord(locationDetails?.facilityDetails?.name) : 'N/A'}</div>
                                        </DetailsDataKeyValueComponent>
                                    </Grid>

                                </Grid>
                            </div>
                        </div>
                    </CardComponent>

                    <div className="clear-fix"/>

                    <div className="location-list-screen mrg-top-25 screen">
                        <div className={"screen-content-wrapper"}>
                            <div className="page-data-wrapper">
                                <div className="page-options">
                                    <div className="page-search">
                                        <SearchComponent
                                            label={"Search Test Order"}
                                            id="search_input"
                                            placeholder={"Search Test Order"}
                                            value={filterData.search}
                                            onChange={handleSearch}
                                        />
                                    </div>
                                    <div className="page-extra-options">
                                        {commonService.checkAccess('TestOrder','testOrderAdd',currentUser?.userAccessModules) && <ButtonComponent
                                            type="button"
                                            color={"primary"}
                                            variant={"contained"}
                                            id="add_test_order_btn"
                                            startIcon={<AddIcon/>}
                                            disabled={!(locationDetails?.isActive)}
                                            handleClick={() => {
                                                dispatch(setLocationDetailsForTestOrder(locationDetails));
                                                dispatch(setFacilityDetailsForLocation(locationDetails?.facilityDetails));
                                                navigate(CommonService._routeConfig.TestOrderCreateRoute())
                                            }}
                                        >
                                            New Test Order
                                        </ButtonComponent>}
                                    </div>
                                </div>
                                <div className="page-data-wrapper t-table-inside-details">
                                    <TestOrderListTableComponent
                                        filterData={filterData}
                                        isColumnFilterVisible={false}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );

};

export default LocationDetailsTestOrdersComponent;
